import { EventTile } from "../../../../components/analysis/tiles";
import {
  Grid,
  Box,
  TablePagination,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { fetchTeamEvents } from "../../../../api/apis";

async function GetTeamEvents(team) {
  const data = await fetchTeamEvents({ year: 2025, team: team });
  return data;
}

export default function EventsPage({ team }) {
  const [eventList, setEventList] = useState([]);

  const [eventLowerBound, setEventLowerBound] = useState(0);
  const [eventsShown, setEventsShown] = useState(12);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    setEventLowerBound(newPage * eventsShown);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(
      Math.floor(page * (eventsShown / parseInt(event.target.value, 10)))
    );
    setEventsShown(parseInt(event.target.value, 10));
    setEventLowerBound(
      Math.floor(page * (eventsShown / parseInt(event.target.value, 10))) *
        parseInt(event.target.value, 10)
    );
  };

  const handleSearchChange = (search) => {
    setSearch(search);
    setPage(0);
    setEventLowerBound(0);
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await GetTeamEvents(team);
      try {
        setEventList(result);
      } catch (error) {
        console.error("Error parsing team data:", error);
        setEventList([]);
      }
    };

    fetchData();
    setPage(0);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={6}>
        <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
          <TextField
            name="searchTeam"
            label="Search"
            sx={{ width: "75%" }}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </Box>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Box sx={{ display: "flex", justifyContent: "right" }}>
          <TablePagination
            count={
              eventList.filter((event) => {
                const { label, location, value, week } = event;

                const cleanSearch = (search ?? "")
                  .toLowerCase()
                  .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

                const matchesSearch = [label, location, value, week].some(
                  (field) =>
                    (field ?? "")
                      .toLowerCase()
                      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
                      .includes(cleanSearch)
                );

                return matchesSearch && event.week != "Testing";
              }).length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={eventsShown}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[12, 24, 48]}
          />
        </Box>
      </Grid>
      {eventList
        .filter((event) => {
          const { label, location, value, week, district } = event;

          const cleanSearch = (search ?? "")
            .toLowerCase()
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");

          const matchesSearch = [label, location, value, week].some((field) =>
            (field ?? "")
              .toLowerCase()
              .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "")
              .includes(cleanSearch)
          );

          return matchesSearch && event.week != "Testing";
        })
        .slice(eventLowerBound, eventLowerBound + eventsShown)
        .map((event) => (
          <EventTile key={event.value} event={event} team={team} />
        ))}
    </Grid>
  );
}
